export default function useUrl() {
  const baseUrl = import.meta.env.VITE_API_BASEURL

  const formattedRedirectUrl = (url: string | string[]): string => {
    let finalUrl = '/dashboard'
    if (typeof url === 'string') {
      finalUrl = url
    }
    return finalUrl.startsWith('/') ? finalUrl : `/${finalUrl}`
  }

  // to be replaced in fetch.ts : #3658
  // https://app.shortcut.com/heypongo/story/3658/r%C3%A9%C3%A9criture-du-composable-fetch
  const getUrlObject = (url: string) => {
    const separator = url.startsWith('/') || baseUrl.endsWith('/') ? '' : '/'
    const urlObject = new URL(`${baseUrl}${separator}${url}`)
    return urlObject
  }

  const setParam = (url: string, params: { [key: string]: any }) => {
    const urlObject = getUrlObject(url)
    const paramsKey = Object.keys(params)[0]
    urlObject.searchParams.set(paramsKey, params[paramsKey].toString())
    const pathname = baseUrl.endsWith('/') ? urlObject.pathname.substring(1) : urlObject.pathname

    return `${pathname}${urlObject.search}`
  }

  const deleteParam = (url: string, paramsKey: string) => {
    const urlObject = getUrlObject(url)
    urlObject.searchParams.delete(paramsKey)
    const pathname = baseUrl.endsWith('/') ? urlObject.pathname.substring(1) : urlObject.pathname

    return `${pathname}${urlObject.search}`
  }

  return {
    formattedRedirectUrl,
    setParam,
    deleteParam,
    getUrlObject
  }
}
